import React from "react";

const SvgRenderer = React.forwardRef((props, ref) => {
    const { id, blockRef, svgString, style, onClick, children } = props;
    const svgElement = React.useMemo(() => {
        if (!svgString) return null;
        // Regex per estrarre il tag svg e i suoi contenuti
        const match = svgString.match(/<svg[\s\S]*?>[\s\S]*?<\/svg>/i);
        if (!match) return null;
        const temp = document.createElement('div');
        temp.innerHTML = match[0];
        const svg = temp.firstElementChild;
        if (!svg) return null;
        // Non applicare gli stili come attributi, li passeremo come prop React
        // Helper to convert kebab-case to camelCase
        const toCamelCase = (str) => str.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
        // List of SVG attributes that need camelCase in React
        const reactSvgAttributes = new Set([
            'accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule',
            'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline',
            'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size',
            'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal',
            'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color',
            'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1',
            'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position',
            'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit',
            'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position',
            'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic',
            'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode',
            'x-height', 'xlink:actuate', 'xlink:arcrole', 'xlink:href', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type',
            'xml:base', 'xml:lang', 'xml:space', 'xmlns', 'xmlns:xlink'
        ]);
        const styleProps = style && typeof style === 'object' ? { style } : {};
        const convertAttributes = (attributes) => {
            const result = {};
            for (const attr of attributes) {
                let name = attr.name;
                if (reactSvgAttributes.has(name)) {
                    name = toCamelCase(name);
                }
                // Do not include style keys as attributes
                if (style && typeof style === 'object' && Object.prototype.hasOwnProperty.call(style, name)) {
                    continue;
                }
                result[name] = attr.value;
            }
            return result;
        };
        const svgChildren = [
            ...Array.from(svg.childNodes).map((node, i) => {
                if (node.nodeType === 1) {
                    return React.createElement(
                        node.nodeName.toLowerCase(),
                        { key: i, ...convertAttributes(node.attributes) },
                        node.textContent
                    );
                } else if (node.nodeType === 3) {
                    return node.textContent;
                }
                return null;
            })
        ];
        if (children) svgChildren.push(children);
        // Prefer ref from React.forwardRef, fallback to blockRef for backward compatibility
        const svgRef = ref || blockRef;
        return React.createElement(
            'svg',
            {
                ...convertAttributes(svg.attributes),
                ...styleProps,
                ref: svgRef,
                ...(id ? { id } : {}),
                ...(typeof onClick === 'function' ? { onClick } : {})
            },
            ...svgChildren
        );
    }, [svgString, style, blockRef, children, ref, id, onClick]);
    return svgElement;
});

export default SvgRenderer;
